import { AfterViewChecked, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
//Detect content overflow and add .overflow class to element
@Directive({
  selector: '[appOverflowClass]',
})
export class OverflowClassDirective implements AfterViewChecked  {

  @Input() className? = 'overflow';
  constructor(private el: ElementRef, private renderer: Renderer2) {}
  ngAfterViewChecked(): void { this.checkOverflow();
  }
  private checkOverflow() {
    const element = this.el?.nativeElement;
    if (element?.scrollHeight > element?.clientHeight) {
      this.renderer.addClass(element, this.className);
    } else {
      this.renderer.removeClass(element, this.className);
    }
  }
}
